pathsAreEqual